import styled from 'styled-components';

export const SMoodWrapper = styled.div`
    align-self: center;
    margin-bottom: 2rem;
`;
